enum UserSubscriptionStatus {
	ACTIVE = "active",
	PAST_DUE = "past_due",
	TRIALING = "trialing",
	PAUSED = "paused",
	CANCELED = "canceled",
}

const displayNames = {
	[UserSubscriptionStatus.ACTIVE]: "Active",
	[UserSubscriptionStatus.PAST_DUE]: "Past Due",
	[UserSubscriptionStatus.TRIALING]: "Trialing",
	[UserSubscriptionStatus.PAUSED]: "Paused",
	[UserSubscriptionStatus.CANCELED]: "Cancelled",
};

const colors = {
	[UserSubscriptionStatus.ACTIVE]: "green",
	[UserSubscriptionStatus.PAST_DUE]: "red",
	[UserSubscriptionStatus.TRIALING]: "magenta",
	[UserSubscriptionStatus.PAUSED]: "magenta",
	[UserSubscriptionStatus.CANCELED]: "magenta",
};

const displayUserSubscriptionStatus = (status: UserSubscriptionStatus) =>
	displayNames[status];

const colorUserSubscriptionStatus = (status: UserSubscriptionStatus) =>
	colors[status];

export {
	UserSubscriptionStatus,
	displayUserSubscriptionStatus,
	colorUserSubscriptionStatus,
};
